export default {
  expandedAccordionBackground: Styles.color.grey.five,
  expandedAccordionFontWeight: '600',
  accordionHoverBackground: Styles.color.grey.five,
};
